<template>
  <section class="descricao">
    <div class="container custom-container">
      <p class="descricao--title">
        <span class="highlight">Por que</span> escolher heliar?
      </p>
      <p class="descricao--text">
        Confira os beneficios que fazem da Heliar a melhor bateria do Brasil:
      </p>
      <div class="row">
        <div class="col-24 col-lg-8">
          <div class="descricao--item">
            <span class="item--icon icon icon-guarantee"></span>
            <div>
              <p class="item--title">Garantia Heliar</p>
              <p class="item--text">
                Oferecemos até 2 anos de garantia em nossas baterias. A maior do
                mercado.
              </p>
            </div>
          </div>
        </div>
        <div class="col-24 col-lg-8">
          <div class="descricao--item">
            <span class="item--icon icon icon-durability"></span>
            <div>
              <p class="item--title">Durabilidade</p>
              <p class="item--text">
                Nossa tecnologia de grades PowerFrame garante até 66% mais
                durabilidade do que as baterias sem essa tecnologia.
              </p>
            </div>
          </div>
        </div>
        <div class="col-24 col-lg-8">
          <div class="descricao--item">
            <span class="item--icon icon icon-thumbs-up"></span>
            <div>
              <p class="item--title">Equipamento Original</p>
              <p class="item--text">
                Heliar atende a exigências internacionais de performance e é
                líder absoluta nas montadoras.
              </p>
            </div>
          </div>
        </div>
      </div>
      <picture class="descricao--img">
        <source
          media="(max-width: 991px)"
          srcset="../assets/descricao-baterias-mobile.png"
        />
        <img src="../assets/descricao-baterias.png" alt="Baterias Heliar" />
      </picture>
    </div>
  </section>
</template>
<script>
export default {
  name: "Descricao",
};
</script>

<style lang="scss">
.descricao {
  color: $cinza-escuro;
  background-color: $second-bg-color;
  padding-top: 42px;
  margin-bottom: 85px;
  &--title {
    font-size: 29px;
    margin-bottom: 13px;
    text-transform: uppercase;
    font-style: italic;
    line-height: normal;
    .highlight {
      font-weight: 800;
    }
  }
  &--text {
    font-size: 16px;
    margin-bottom: 30px;
  }
  &--img {
    padding-top: 40px;
    width: 100%;
    margin-bottom: 0;
    display: inline-block;
    img {
      max-width: 100%;
      height: auto;
    }
  }
  &--item {
    display: flex;
    .item {
      &--icon {
        color: $verde-heliar;
        font-size: 62px;
        display: inline-block;
        margin-right: 10px;
        line-height: 0;
      }
      &--title {
        font-weight: 600;
        font-size: 16px;
        margin-bottom: 0;
        line-height: normal;
      }
      &--text {
        font-size: 16px;
        line-height: normal;
        margin-bottom: 0;
      }
    }
  }
}

@media (max-width: 1200px) {
  .descricao {
    &--title {
      font-size: 26px;
    }
    &--text {
      font-size: 14px;
    }
    &--item {
      .item {
        &--text {
          font-size: 14px;
        }
        &--text {
          font-size: 14px;
        }
        &--icon {
          font-size: 50px;
        }
      }
    }
  }
}

@media (max-width: 991px) {
  .descricao {
    position: relative;
    padding-bottom: calc(100vw * 0.45);
    margin-bottom: 106px;
    padding-top: 56px;
    &--title {
      font-size: 46px;
      margin-bottom: 21px;
      text-align: center;
    }
    &--text {
      display: none;
    }
    &--item {
      border-bottom: 1px solid #d9d9d9;
      padding-top: 35px;
      padding-bottom: 35px;
      .item {
        &--icon {
          font-size: 86px;
          margin-right: 39px;
        }
        &--title {
          font-size: 28px;
        }
        &--text {
          font-size: 28px;
        }
      }
    }
    .row {
      .col-24 {
        &:last-child {
          .descricao {
            &--item {
              border: none;
            }
          }
        }
      }
    }
    &--img {
      width: 100vw;
      position: absolute;
      left: 0;
      bottom: 0;
      padding-top: 21px;
    }
  }
}

@media (max-width: 767px) {
  .descricao {
    &--title {
      font-size: 30px;
    }
    &--item {
      .item {
        &--title {
          font-size: 20px;
        }
        &--text {
          font-size: 20px;
        }
      }
    }
  }
}
@media (max-width: 575px) {
  .descricao {
    &--title {
      font-size: 28px;
    }
    &--item {
      .item {
        &--title {
          font-size: 14px;
        }
        &--text {
          font-size: 14px;
        }
        &--icon {
          font-size: 60px;
          margin-right: 15px;
        }
      }
    }
  }
}
</style>
